import { Typography } from '@mui/material';
import { proAccountThemeCoreUI } from '../../themes';

export type BlockScoreProps = {
  score?: number;
};

/**
 * Props for configuring a block score component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {number} score - The score to display.
 */
export const BlockScore = ({ score }: BlockScoreProps) => {
  const getColorForScore = () => {
    if (!score) {
      return proAccountThemeCoreUI.palette.grey[600];
    }
    if (score >= 65) {
      return proAccountThemeCoreUI.palette.success.dark;
    }
    if (score < 65 && score >= 46) {
      return proAccountThemeCoreUI.palette.warning.dark;
    }
    return proAccountThemeCoreUI.palette.error.dark;
  };

  return (
    <>
      <Typography
        fontSize="12px"
        fontWeight="bold"
        color="common.white"
        sx={{
          backgroundColor: getColorForScore(),
          padding: '0 4px',
          display: 'inline-block',
          borderRadius: '4px',
        }}
      >
        {score ? `${score}%` : '-'}
      </Typography>
    </>
  );
};
